/**
 * Capitalize the each first letter of the word and lowercase the rest
 * @param text
 * @returns capitalized text
 */
export const capitalize = (text: string) => {
  return text
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
